import { createSelector } from "reselect";

// Base selector
const getDashboardState = state => state.dashboard || {};

// Selectors
export const selectDashboardData = createSelector(
  getDashboardState,
  dashboard => dashboard.data
);

export const selectDashboardLoading = createSelector(
  getDashboardState,
  dashboard => dashboard.loading
);

export const selectDashboardError = createSelector(
  getDashboardState,
  dashboard => dashboard.error
);

export const selectDashboardLastUpdated = createSelector(
  getDashboardState,
  dashboard => dashboard.lastUpdated
);
